import { Link } from 'react-router-dom';

import { meta } from '../../global/config/api';
import CHANGELOG from './changelog';

import './styles/footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const CURRENT_YEAR = new Date().getFullYear();

export default function Footer() {
    return (
        <footer className="footer">
            <span className="footer__name">{meta.projectName}</span>
            <span className="footer__version">{CURRENT_VERSION}</span>
            <Link to="/legal" className="footer__legal">Privacidad y términos</Link>
            <span className="footer__copy">© {CURRENT_YEAR}</span>
        </footer>
    );
}
